import React, { createContext } from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';
import Header from '../Components/Header';

export const BooksContext = createContext([])

const Root = () => {
    const Books = useLoaderData()
    return (
        <BooksContext.Provider value={Books}>
            <Header></Header>
            <Outlet></Outlet>
        </BooksContext.Provider>
    );
};

export default Root;